import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const originalCreateElement = React.createElement;
React.createElement = (type, props, ...children) => {
  if (type === "img") {
    props = {
      loading: "lazy",
      decoding: "async",
      ...props,
    };
  }

  return originalCreateElement(type, props, ...children);
};

const applyImageDefaults = (node) => {
  if (!(node instanceof HTMLImageElement)) return;
  if (!node.hasAttribute("loading")) node.setAttribute("loading", "lazy");
  if (!node.hasAttribute("decoding")) node.setAttribute("decoding", "async");
};

if (typeof window !== "undefined" && "MutationObserver" in window) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        applyImageDefaults(node);
        node.querySelectorAll?.("img").forEach(applyImageDefaults);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
